import axios from 'axios';
import { useQuery } from 'react-query';
import Http from '../services/http';

export function useUsers() {
  return useQuery<[]>(
    'users',
    async () => {
      const { data } = await axios.get(`${process.env.REACT_APP_API}/users`, {
        headers: {
          Authorization: `Bearer ${Http.accessToken}`,
        },
        timeout: 30000,
      });
      return data;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 15 * 1000, // 15s; skip refetching the heavy list on quick remounts
      retry: 1, // one bounded retry instead of react-query's default of 3
    }
  );
}
